export default __webpack_public_path__ + "static/media/m-fsk-24.80a55328.jpg";